import { State } from '../../type'
import { moduleName } from './constants'
import { IChatDetails, IChatDetailsState } from './types'

const getState = (state: State): IChatDetailsState => state[moduleName]

export const getChatDetails =
  <T extends IChatDetails>() =>
  (state: State) => {
    const stateSlice = getState(state)
    return stateSlice.details as T | null
  }

export const getChatMembers = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.members
}

export const getCountOfUnreadMessages = (state: State): number => {
  const stateSlice = getState(state)
  return stateSlice.details?.unread_messages_count || 0
}
